import { DateTime } from '~/components';
import React from 'react';
import { Tag } from './PageComponents';

export default function StatusTag({ clientApproval, locale }) {
  return (
    <Tag>
      {
        {
          not_sent: clientApproval.status.name,
          sent: (
            <span>
              Sent to{' '}
              {clientApproval.emails.map((email, index) => [
                index > 0 && ', ',
                <a key={index} href={`mailto:${email}`}>
                  {email}
                </a>,
              ])}{' '}
              on <DateTime value={clientApproval.sentAt} locale={locale} />
            </span>
          ),
          submitted: (
            <span>
              Submitted {clientApproval.reviewerName && `by ${clientApproval.reviewerName}`} on{' '}
              <DateTime value={clientApproval.submittedAt} locale={locale} />
            </span>
          ),
        }[clientApproval.statusId]
      }
    </Tag>
  );
}
